import { ActionType } from "../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../react-core/Flux/BaseStore";
import { SubAccountType } from "../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { AccountStatus } from "../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { ClientAccount } from "../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { SubAccount } from "../../../Wrap/Models/Domains/Account/SlAccounts/SubAccount";

import { ClientAccountDispatcher } from "./Variable";

export interface ClientAccountStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    clientAccountInfo?: ClientAccount;
}

export class ClientAccountStoreStatic extends BaseStore<ClientAccountStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ClientAccountDispatcher, (actionData) =>
            this.onClientAccountStoreResponse(actionData)
        );
    }

    public getLastResult(): ClientAccountStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ClientAccountStoreStaticState {
        return { actionType: ActionType.Loading };
    }

    public getClientAccountInfo(): ClientAccount {
        return this.getState().clientAccountInfo;
    }

    public getHiercharyIdByClAccountId(clAccountId: string): string {
        const clientInfo = this.getState().clientAccountInfo;
        let accountViewSelected = "";
        if (clientInfo && clAccountId) {
            const subAccount = clientInfo.SubAccounts.filter((x) => x.ClAccountId == clAccountId);
            if (subAccount.length > 0) {
                accountViewSelected = subAccount[0].HierarchyId;
            }
        }
        return accountViewSelected;
    }

    public getActiveClientSubAccounts(): SubAccount[] {
        return this.getState().clientAccountInfo.SubAccounts.filter(
            (subaccount) => subaccount.Status == AccountStatus.Active || subaccount.Status == AccountStatus.Closing
        );
    }

    public flushStore(): void {
        this.resetState();
    }

    private onClientAccountStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({
                    actionType: actionData.actionType,
                    isLoading: false,
                    clientAccountInfo: actionData.payload,
                });
                break;
            case ActionType.Error:
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
